/** App logos in /public — favicon file was SVG mislabeled as .png; use .svg for <img> tags. */
export const LOGO_SRC = '/dpm-logo.svg';
export const LOGO_DARK_SRC = '/dpm-logo.svg';
export const LOGO_ALT = 'Digital Presence Matters';
